/* global axios */
import ApiClient from './ApiClient';

// Client dos diretórios (pastas) de fluxos — #1071. Recurso IRMÃO de
// automation_flows, e não aninhado: a pasta existe sem fluxo dentro.
//
// `create`/`update`/`delete` vêm do ApiClient e já embrulham o payload no
// `automation_flow_directory` que o `params.require` do controller espera.
class AutomationFlowDirectoriesAPI extends ApiClient {
  constructor() {
    super('automation_flow_directories', { accountScoped: true });
  }

  // Sem paginação de propósito: a lista de pastas é curta por natureza e a tela
  // precisa dela inteira para montar o filtro e o seletor de "mover para".
  get() {
    return axios.get(this.url);
  }
}

export default new AutomationFlowDirectoriesAPI();
